common.View.create('photo_album::website.modules.photoAlbum.Show', {
    onDOMLoad() {
        lightGallery(this.element.find('.lightgallery').get(0), {
            selector: '.galleryItem',
        });
    },
});
